import React from "react";
import ProblemStatement from "../UiElements/ProblemStatement";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

function ViewAnswers() {

  return (
    <>
      <div
        style={{"width":"86%","background":"white","color":"black","borderRadius":"20px","border":"4px solid gray","height":"86vh","display":"flex","flexDirection":"column","justifyContent":"center"}}
      >
        <ProblemStatement />
        <Link to="/instructor/show_steps">
        <Button
          className="CustomButton"
          variant="contained"
          size="large"
          style={{
            display: "block",
            width: "auto",
            margin: "auto",
            marginTop: "60px",
          }}
        >
          View Answers
        </Button>
        </Link>
      </div>
    </>
  );
}

export default ViewAnswers;
